import { useMutation } from '@tanstack/react-query';
import { returnLoaner } from '../services/providerDeviceService';
import providerService from '../services/providerService';

/**
 * Custom hook for the return loaner mutation.
 * @returns {Object} React Query useMutation result
 */
export const useReturnLoaner = () => {
  const { providerId } = providerService.getProviderDetails();

  return useMutation({
    mutationFn: ({ assetId, patientId }) =>
      returnLoaner(providerId, assetId, patientId),
  });
};
